import './common/SideBySideDivs.css'; // Import CSS file for styling
import React, { type FC } from 'react';
import { PropertyViewerContextProvider } from '../contexts/PropertyViewer';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppSettingsProvider } from '../contexts/AppSettings';
import { FilteringProvider } from '../contexts/Filtering';
import { PrimeReactProvider } from 'primereact/api';
import Tailwind from 'primereact/passthrough/tailwind';
import { twMerge } from 'tailwind-merge';
import { store } from '../redux/store';
import { Provider } from 'react-redux';
import { PublicViewer } from '../features/public-view/presentation/components/PublicViewer';
import { enableMapSet } from 'immer';
import { PropertiesViewAppProps } from '../utility/types';
import { LoginPromptProvider } from './common/LoginPromptContext';
enableMapSet();

// Create a client
const queryClient = new QueryClient();

const PropertiesViewApp: FC<PropertiesViewAppProps> = ({
  mapKey,
  listSortId,
  isLoggedIn,
}) => {
  return (
    <Provider store={store}>
      <PrimeReactProvider
        value={{
          unstyled: false,
          pt: Tailwind,
          ptOptions: {
            mergeSections: true,
            mergeProps: true,
            classNameMergeFunction: twMerge,
          },
        }}
      >
        <QueryClientProvider client={queryClient}>
          <PropertyViewerContextProvider listSortId={listSortId}>
            <FilteringProvider>
              {' '}
              {/* <-- Handle search filtering criteria */}
              <AppSettingsProvider>
                <LoginPromptProvider isLoggedIn={isLoggedIn}>
                  <PublicViewer mapKey={mapKey} listSortId={listSortId} />
                </LoginPromptProvider>
              </AppSettingsProvider>
            </FilteringProvider>
          </PropertyViewerContextProvider>
        </QueryClientProvider>
      </PrimeReactProvider>
    </Provider>
  );
};

export default PropertiesViewApp;
